import React from 'react';
import style from '../../css/homepage/Welcome.module.css';

const WelcomeImage = () => {
    return (
        <div className="container-fluid">
            <div className={`container ${style.container}`}>
                <h1 className={style.header}>Welcome to life of ALGO</h1>
                <p className={style.subheader}>A JOURNEY WORTH TAKING !!</p>
                <div className="row align-items-center">
                    <div className="col-12 col-md-7 order-1 order-md-1 text-center">
                        <img
                            src="/images/step4.svg"
                            alt="Welcome to Life of ALGO"
                            className={style.imagesvg}
                        />
                    </div>

                    <div className={`col-12 col-md-5 order-2 order-md-2 ${style.stepsContainer}`}>
                        <div className={style.step}>
                            <h1>LEARN</h1>
                            <p>Swing trading advance strategies!</p>
                            <p className={style.stepsnumber}>1</p>
                        </div>
                        <div className={style.step}>
                            <h1>TRADE</h1>
                            <p>Practice stock & fundamentals</p>
                            <p className={style.stepsnumber}>2</p>
                        </div>
                        <div className={style.step}>
                            <h1>ALGO</h1>
                            <p>Stock selection & fundamentals with help of AI & ALGO</p>
                            <p className={style.stepsnumber}>3</p>
                        </div>
                        <div className={style.step}>
                            <h1>REPEAT</h1>
                            <p>Create a loop of strategy and execution for ezzz money!</p>
                            <p className={style.stepsnumber}>4</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default WelcomeImage;
